import React from 'react';
import { howItWorksSteps } from '../data/mockData';
import { FileText, MessageSquare, CheckCircle } from 'lucide-react';
import { appName } from '../config/branding';

const stepIcons = [
  <FileText size={32} className="text-[#37b34a]" />,
  <MessageSquare size={32} className="text-[#37b34a]" />,
  <CheckCircle size={32} className="text-[#37b34a]" />
];

const HowItWorks = () => {
  return (
    <section className="py-16 md:py-20 bg-gray-50" id="how-it-works">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            How {appName} works
          </h2>
          <p className="text-gray-500 text-base max-w-lg mx-auto">
            Getting help has never been easier. Follow these simple steps to find the perfect professional.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {howItWorksSteps.map((step, idx) => (
            <div key={idx} className="text-center group">
              <div className="w-20 h-20 rounded-2xl bg-[#37b34a]/10 flex items-center justify-center mx-auto mb-5 group-hover:bg-[#37b34a]/20 transition-colors duration-300">
                {stepIcons[idx]}
              </div>
              <div className="text-[#37b34a] text-xs font-bold uppercase tracking-wider mb-2">
                Step {step.step}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {step.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed max-w-xs mx-auto">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
